import { render, staticRenderFns } from "./role-component.vue?vue&type=template&id=a5e5f5b6&scoped=true"
import script from "./role-component.vue?vue&type=script&lang=js"
export * from "./role-component.vue?vue&type=script&lang=js"
import style0 from "./role-component.vue?vue&type=style&index=0&id=a5e5f5b6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e5f5b6",
  null
  
)

export default component.exports